import { render, staticRenderFns } from "./xtdz.vue?vue&type=template&id=5e479076&scoped=true&"
import script from "./xtdz.vue?vue&type=script&lang=js&"
export * from "./xtdz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e479076",
  null
  
)

export default component.exports